/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface StorageControllerDownloadFileV1$Params {

/**
 * 파일 URL
 */
  url: string;
}

export function storageControllerDownloadFileV1(http: HttpClient, rootUrl: string, params: StorageControllerDownloadFileV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'url'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, storageControllerDownloadFileV1.PATH, 'get');
  if (params) {
    rb.path('url', params.url, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'url'?: string;
      }>;
    })
  );
}

storageControllerDownloadFileV1.PATH = '/api/v1/storage/download/{url}';
